




































































































































































































import Vue from 'vue'
import { iam } from '@rhitics/core'
import { slackContact } from './config'
import RtsPacManMixin from './RtsPacManMixin'
import ModifierDialog from './widgets/ModifierDialog.vue'

interface Data {
  isMenuActivated: boolean
  isLoading: boolean
  isInitialized: boolean
  isModifierActivated: boolean
  permissionData: {
    group: { [name: string]: any } | null
    role: { [name: string]: any } | null
    policy: { [name: string]: any } | null
  }
  activePermission: {
    group: Array<any>
    role: Array<any>
    policy: Array<any>
  }
  activeRoute: string | null
  slackContact: { [name: string]: any }
}

export default Vue.extend({
  name: 'RtsPacMan',

  components: {
    ModifierDialog
  },

  mixins: [RtsPacManMixin],

  data(): Data {
    return {
      isMenuActivated: false,
      isLoading: false,
      isInitialized: false,
      isModifierActivated: false,
      activeRoute: null,
      permissionData: {
        group: null,
        role: null,
        policy: null
      },
      activePermission: {
        group: [],
        role: [],
        policy: []
      },
      slackContact
    }
  },

  computed: {
    permissionOptions(): { [name: string]: Array<any> } {
      return Object.keys(this.permissionData).reduce((options, key) => {
        if (key === 'user') return options
        options[key] = this.permissionData[key] ? this.permissionData[key].data.map(info => info.name) : []
        return options
      }, {})
    },

    userPermission() {
      const { groups, roles } = this.$auth.user

      return {
        group: groups.map(group => group.name),
        role: roles.map(role => role.name),
        policy: this.$auth.allPolicies.map(policy => policy.name)
      }
    },

    routeOptions(): Array<string> {
      // @ts-ignore
      return this.$router.options.routes.map(route => route.name)
    },

    localeOptions() {
      return Object.keys(this.$i18n.messages)
    }
  },

  watch: {
    isModifierActivated: {
      handler(val) {
        if (!val) this.isMenuActivated = false
      }
    },
    isDarkMode: {
      async handler(val) {
        this.$vuetify.theme.dark = val
        const theme = val ? 'dark' : 'light'
        this.updateTheme(theme)
      }
    }
  },

  async created() {
    if (this.$auth.user) await this.initialize()
  },

  methods: {
    async initialize() {
      await this.fetchPermissionData()

      this.syncActivePermission().syncActiveRoute()

      this.isInitialized = true
    },

    async updateTheme(theme) {
      if (!this.$auth.user) return
      this.isLoading = true
      this.$auth.user.theme = theme
      await iam.user.updateV2(this.$auth.user)
      this.isLoading = false
    },

    updatePermission() {
      const { activePermission, permissionOptions, $auth } = this

      Object.keys(activePermission).forEach(key => {
        const getPermissionNameByIndex = index => ({
          name: permissionOptions[key][index]
        })
        const methodList = {
          role: 'setRoles',
          group: 'setGroups',
          policy: 'setPolicies'
        }
        const method = $auth[methodList[key]]
        const args = activePermission[key].map(getPermissionNameByIndex)

        method(args)
      })

      this.syncActivePermission()
    },

    updateRoute() {
      // @ts-ignore
      this.$router.push({ name: this.activeRoute })

      this.syncActiveRoute()
    },

    syncActivePermission() {
      const { userPermission, activePermission, permissionOptions } = this
      Object.keys(userPermission).forEach(key => {
        const getPermissionIndexByName = name => permissionOptions[key].indexOf(name)
        activePermission[key] = userPermission[key].map(getPermissionIndexByName)
      })
      iam.user.update(this.$auth.user, userPermission.policy, activePermission.group, activePermission.role)
      return this
    },

    syncActiveRoute() {
      this.activeRoute = this.$route.name || null

      return this
    },

    async fetchPermissionData() {
      this.isLoading = true
      const queue = Object.keys(this.permissionData).map(async key => {
        const data = await iam[key].fetchAll()
        this.permissionData[key] = data || null
        return data
      })
      await Promise.all(queue)

      this.isLoading = false
    },

    async logHandler() {
      this.isLoading = true

      if (this.$auth.isLogin) await this.$auth.logout()
      else await this.$auth.login()

      this.isLoading = false

      window.location.reload()
    }
  }
})
